import { ModelSagres } from "@/types/model-sagres"

//TO-DO: Passar o limpar() para a model-sagres
export class FiltrosPrazoDeVencimentoLRFCI extends ModelSagres {
    filtro?: string
    exercicio?: number
    periodoPrestacao?: string
    periodoRelatorio?: number

    limpar(): void {
        this.filtro = undefined
        this.exercicio = undefined
        this.periodoPrestacao = undefined
        this.periodoRelatorio = undefined
    }
}